import { useState } from "react";
import { supabase } from "../supabaseClient";

const getEffectiveDocId = (docId) => {
  if (docId) return docId;
  const cached = sessionStorage.getItem('temp_photo_session');
  if (cached) return cached;
  const id = 'temp_' + Date.now();
  sessionStorage.setItem('temp_photo_session', id);
  return id;
};

const PhotoUpload = ({ docId, formType, onUploaded }) => {
  const [photos, setPhotos] = useState([]);
  const [uploading, setUploading] = useState(false);

  const handleSelect = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setUploading(true);
    const effectiveDocId = getEffectiveDocId(docId);
    const uploaded = [];
    for (const file of files) {
      const ext = file.name.split('.').pop();
      const path = `${formType}/${effectiveDocId}/${Date.now()}.${ext}`;
      const { error } = await supabase.storage
        .from('clinical-photos')
        .upload(path, file, { contentType: file.type, upsert: false });
      if (!error) uploaded.push({
        path, preview: URL.createObjectURL(file)
      });
    }
    const all = [...photos, ...uploaded];
    setPhotos(all);
    onUploaded?.(all.map(p => p.path));
    setUploading(false);
  };

  return (
    <div style={{ marginTop: 12, padding: 12,
      background: '#F5F0FA', borderRadius: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center',
        gap: 10, marginBottom: 8, flexWrap: 'wrap' }}>
        <span style={{ fontWeight: 600, fontSize: 14 }}>
          📎 Clinical Photos
        </span>
        <label style={{ cursor: 'pointer', background: '#6B2D9E',
          color: '#fff', padding: '4px 12px', borderRadius: 6,
          fontSize: 12 }}>
          📷 Camera
          <input type="file" accept="image/*" capture="environment"
            multiple style={{ display: 'none' }}
            onChange={handleSelect} />
        </label>
        <label style={{ cursor: 'pointer', background: '#6B2D9E',
          color: '#fff', padding: '4px 12px', borderRadius: 6,
          fontSize: 12 }}>
          🖼️ Gallery
          <input type="file" accept="image/*"
            multiple style={{ display: 'none' }}
            onChange={handleSelect} />
        </label>
        {uploading && <span style={{ fontSize: 12, color: '#6B2D9E' }}>
          Uploading...</span>}
        {!uploading && photos.length > 0 && (
          <span style={{ fontSize: 12, color: '#10B981', fontWeight: 600 }}>
            ✓ {photos.length} photo{photos.length === 1 ? '' : 's'} attached
          </span>
        )}
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {photos.map((p, i) => (
          <div key={i} style={{ position: 'relative' }}>
            <img src={p.preview} alt="clinical"
              style={{ width: 72, height: 72, objectFit: 'cover',
                borderRadius: 6, border: '1px solid #ccc',
                display: 'block' }} />
            <div style={{
              position: 'absolute', top: -6, right: -6,
              width: 20, height: 20, borderRadius: '50%',
              background: '#10B981', color: '#fff',
              display: 'flex', alignItems: 'center',
              justifyContent: 'center', fontSize: 12,
              fontWeight: 'bold',
              boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
            }}>✓</div>
          </div>
        ))}
      </div>
      {photos.length === 0 && (
        <p style={{ fontSize: 12, color: '#aaa', margin: 0 }}>
          No photos. Tap "📷 Camera" or "🖼️ Gallery" above.
        </p>
      )}
    </div>
  );
};
export default PhotoUpload;
